<button class="btn btn-submenu-color btn-sm" routerLinkActive="btn-submenu-active-color"
  routerLink="/admin/tools/clear-cache">
  {{ 'CLEAR_CACHE' | translate }}
</button>

<button class="btn btn-submenu-color btn-sm" routerLinkActive="btn-submenu-active-color"
  routerLink="/admin/tools/pin-generator" *ngIf="resourcesOnDatabase">
  {{ 'PIN_GENERATOR' | translate }}
</button>